


















































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import * as Common from "../commons/common"
import TextDirectionToggle from "../components/TextDirectionToggle.vue";
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import { BaseSheetField, AnswerText } from "../modules/student/DigitalReport"

export default defineComponent({
  components: {
    "text-direction-toggle": TextDirectionToggle,
    "v-swatches": VSwatches,
  },
  props: {
    position: {
      type: Number as PropType<number>,
      required: true,
    },
    selectedPosition: {
      type: Number as PropType<number>,
      required: true,
    },
    areaHeight: {
      type: Number as PropType<number>,
      required: true,
    },
    selectedBaseSheetField: {
      type: Object || null as PropType<any>,
      required: false,
      default: null
    },
    drawMode: {
      type: Number as PropType<number>,
      required: true,
    },
    isEditable: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    isTextDrawable: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    isCanvasDrawable: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    isImageDrawable: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    direction: {
      type: Number as PropType<number>,
      required: true,
    },
    drawColor: {
      type: String as PropType<string>,
      required: true,
    },
    thickness: {
      type: Number as PropType<number>,
      required: true,
    },
    fontSize: {
      type: Number as PropType<number>,
      required: true
    },
    lineHeight: {
      type: Number as PropType<number>,
      required: true
    },
    fieldMargin: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup (props, context) {

    const DrawModeEnum = Common.DrawModeEnum;
    const AnswerTypeEnum = Common.AnswerTypeEnum;

    const addAnswerImage = (event: any) => {
      context.emit("add-answer-image", event);
    }

    const changeDrawMode = (drawMode: number) => {
      context.emit("change-draw-mode", drawMode);
    }

    const drawColorChanged = (drawColor: string) => {
      context.emit("draw-color-changed", drawColor);
    }

    const thicknessChanged = (thickness: number) => {
      context.emit("thickness-changed", thickness);
    }

    const toolbarPositionChanged = (position: number) => {
      context.emit("toolbar-position-changed", position);
    }

    /************************************************************
     * テキストスタンプ追加
     ************************************************************/

    const addTextStamp = () => {
      context.emit("change-draw-mode", DrawModeEnum.None);
      context.emit("add-text-stamp-field-center");
    }

    return {
      // ...toRefs(state),
      DrawModeEnum,
      AnswerTypeEnum,
      addAnswerImage,
      changeDrawMode,
      drawColorChanged,
      thicknessChanged,
      toolbarPositionChanged,
      addTextStamp,
    }
  }
});
